import {
  borderRadius,
  Dropdown,
  DropdownList,
  Icon,
  typographyV2,
} from '@toggle/design-system';
import styled, { css } from 'styled-components';

import { AssetLogoContainer } from '~/components/asset-logo-container/AssetLogoContainer';

export const LogoAndTickerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: flex-start;
  align-items: center;
`;

export const Text = styled.span<{ $color?: string }>`
  ${typographyV2.bodySm};

  ${({ $color }) =>
    $color &&
    css`
      color: ${$color};
    `}
`;

export const DisabledText = styled.span`
  color: var(--text-disabled);
  ${typographyV2.uiXs}
`;

export const StyledAssetLogoContainer = styled(AssetLogoContainer)`
  ${borderRadius.rFull};
`;

export const StyledDropdown = styled(Dropdown)`
  position: absolute;
  inset: 0;

  ${Dropdown.Styled.DropdownListContainer} {
    width: 350px;
    max-height: 281px;
    z-index: var(--z-index-table-cell);
  }

  ${DropdownList.Styled.DropdownListRoot} {
    position: relative !important;
    left: 0 !important;
    padding-right: 8px;
  }
`;

export const Root = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
`;

export const IconWrapper = styled.div`
  width: 100%;
  height: 100%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const ContentWrapper = styled.div`
  width: auto;
  height: 100%;
`;

export const StyledIcon = styled(Icon)`
  width: 16px;
`;

export const NoneOfTheAboveContentWrapper = styled.div`
  padding: 8px;
  padding-right: 0px;
  ${borderRadius.r1}

  &:hover {
    background-color: var(--surface-hover);
  }
`;

export const NoneOfTheAboveWrapper = styled.div`
  ${typographyV2.bodySm};
  padding: 8px;
  padding-right: 0px;
  border-top: 1px solid var(--border-soft);
  cursor: pointer;
`;

export const NoneOfTheAboveLabel = styled.div`
  ${typographyV2.bodySm};
`;
